import { QueryClient } from "@tanstack/react-query"
import { createBrowserHistory, createMemoryHistory } from "history"
import { createStore, applyMiddleware, combineReducers, compose } from "redux"
import { createReduxHistoryContext, LOCATION_CHANGE } from "redux-first-history"
import { responsiveStoreEnhancer } from "redux-responsive"
import "regenerator-runtime/runtime"
import createSagaMiddleware from "redux-saga"

import { QUERY_CLIENT_CACHE_EXPIRY } from "helpers/application"

import appReducers from "./reducers"

export let history =
  typeof window !== "undefined"
    ? createBrowserHistory()
    : // since the server has no HTML5 push states,
      // history must be temporarily created in memory
      // on the client, we can go ahead and make a standard
      // `history` state
      createMemoryHistory()

// redux logger
// if (sl.config.env === "development" && !sl.server) {
//   const { logger } = require("redux-logger")
//   middlewares.push(logger)
// }

let storeOut = null

// https://github.com/salvoravida/redux-first-history/blob/master/src/reducer.ts
export const createRouterReducer = ({ basename }) => {
  const initialState = {
    action: null,
    basename,
    location: null,
  }

  return (state = initialState, { type, payload }) => {
    if (type === LOCATION_CHANGE) {
      let { location, action } = payload || {}

      if (
        basename &&
        location &&
        location.pathname &&
        location.pathname.startsWith(basename)
      ) {
        location = {
          ...location,
          pathname: location.pathname.slice(basename.length) || "/",
        }
      }

      return {
        ...state,
        action,
        location,
      }
    }

    return state
  }
}

export const configureStore = (preloadData) => {
  const { createReduxHistory, routerMiddleware } = createReduxHistoryContext({
    basename: sl.basename,
    history,
  })

  const sagaMiddleware = createSagaMiddleware({
    onError: (e) => {
      console.error(e.stack)
    },
  })

  const middlewares = [routerMiddleware, sagaMiddleware]
  const newStore = createStore(
    combineReducers({
      ...appReducers,
      router: createRouterReducer({ basename: sl.basename }),
    }),
    preloadData,
    compose(responsiveStoreEnhancer, applyMiddleware(...middlewares))
  )
  storeOut = newStore
  history = createReduxHistory(newStore)

  if (typeof window !== "undefined") {
    const rootSaga = require("./sagas")
    sagaMiddleware.run(rootSaga.default)
  }
  return newStore
}

export const store = storeOut

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: QUERY_CLIENT_CACHE_EXPIRY,
      staleTime: QUERY_CLIENT_CACHE_EXPIRY,
    },
  },
})
